import React, { useState } from 'react';
import { siteContent } from '../data/mock';
import { Wrench, Leaf, Users } from 'lucide-react';

export const CategorySelector = () => {
  const { categorySelector } = siteContent;
  const [selected, setSelected] = useState('trades');
  
  const icons = {
    'trades': Wrench,
    'home-garden': Leaf,
    'local-services': Users
  };
  
  const selectedCategory = categorySelector.categories.find(c => c.id === selected);

  return (
    <section id="category-selector" className="bg-white border-b border-stone-200">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        {/* Question */}
        <h2 className="text-2xl sm:text-3xl font-bold text-stone-900 text-center">
          {categorySelector.question}
        </h2>
        
        {/* Category Buttons */}
        <div className="mt-8 grid gap-3 sm:grid-cols-3">
          {categorySelector.categories.map((category) => {
            const Icon = icons[category.id];
            const isSelected = selected === category.id;
            return (
              <button
                key={category.id}
                onClick={() => setSelected(category.id)}
                className={`
                  flex items-center gap-3 p-4 sm:p-5 rounded-xl border-2 text-left transition-all
                  ${isSelected 
                    ? 'border-emerald-700 bg-emerald-700 text-white' 
                    : 'border-stone-200 bg-stone-50 text-stone-700 hover:border-stone-400'
                  }
                `}
              >
                <div className={`
                  w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0
                  ${isSelected ? 'bg-emerald-800' : 'bg-[#2C3E50]'}
                `}>
                  <Icon className={`w-5 h-5 ${isSelected ? 'text-white' : 'text-white'}`} />
                </div>
                <span className="font-medium">{category.label}</span>
              </button>
            );
          })}
        </div>
        
        {/* Dynamic Content */}
        <div className="mt-10 max-w-2xl mx-auto text-center transition-opacity duration-200">
          <h3 className="text-xl sm:text-2xl font-semibold text-stone-900">
            {selectedCategory.headline}
          </h3>
          <ul className="mt-6 space-y-3">
            {selectedCategory.bullets.map((bullet, index) => (
              <li key={index} className="text-stone-600">
                {bullet}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
